var __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof mfe_seller_estimation_address_entrypoint !== "undefined") return resolve();
	__webpack_require__.l("https://www.logic-immo.com/assets/mfes/seller_estimation_address_entrypoint/v1/client/remoteEntry.js", (event) => {
		if(typeof mfe_seller_estimation_address_entrypoint !== "undefined") return resolve();
		var errorType = event && (event.type === 'load' ? 'missing' : event.type);
		var realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		reject(__webpack_error__);
	}, "mfe_seller_estimation_address_entrypoint");
}).then(() => (mfe_seller_estimation_address_entrypoint));